import { useEffect, useMemo, useRef, useState } from 'react'
import PageHeader from '../../components/PageHeader'
import Select from "react-select"
import ReactMultiSelect from '../../components/react-select-alloption';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"
import { LMSBASEURL } from '../../config/apiUrls';
import Swal from 'sweetalert2';
import EmailEditor from '../../components/email_editor';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { stream_data } from '../../config/stream_data';
import PercentageFilter from '../../components/percentage-filter';

function isSameDate(date1, date2) {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
}

function CreateInstituteAnnouncement() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const role = sessionStorage.getItem("role");
    const dashboardPath = role === 'Institute' ? '/institute-dashboard' : '/dashboard';
    const [programsListData, setProgramsListData] = useState([]);
    const [studentBatchListData, setStudentBatchListData] = useState([])
    const [studentListData, setStudentListData] = useState([]);
    const [selectedNotiType, setSelectedNotiType] = useState(null)
    const [selectedDegree, setSelectedDegree] = useState([]);
    const [selectedStudyingYear, setSelectedStudyingYear] = useState([]);
    const [allDegrees, setAllDegrees] = useState([]);
    const [selectedyear, setSelectedYear] = useState(null)
    const [selectedMessType, setSelectedMessType] = useState(null)
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [selectedBatchStudents, setSelectedBatchStudents] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState([])
    const [selectedProgramBatch, setSelectedProgramBatch] = useState([])
    const [NotificationBody, setNotificationBody] = useState(null)
    const [NotificationTitle, setNotoficationTitle] = useState(null)
    const [selectedDate, setSelectedDate] = useState(new Date());
    const instituteId = sessionStorage.getItem("instituteId");
    const instituteLoginId = sessionStorage.getItem("id");
    const token = process.env.REACT_APP_API_TOKEN;
    const [html, setHtml] = useState('<p></p>');
    const editorRef = useRef();
    const [errors, setErrors] = useState({});
    const getProgramId = sessionStorage.getItem("program_category_id")
    const [studendListLoad, setStudendListLoad] = useState(false)
    const [filterValues, setFilterValues] = useState([]);

    const validateForm = () => {
        const newErrors = {};

        if (!selectedNotiType) {
            newErrors.selectedNotiType = "Notification type is required.";
        }

        // if (getProgramId && (!selectedProgram || selectedProgram.length === 0)) {
        //     newErrors.selectedProgram = "Please select at least one program.";
        // }

        if (selectedNotiType?.value !== "bulk" && (!selectedStudents || selectedStudents.length === 0)) {
            newErrors.selectedStudents = "Please select at least one student.";
        }

        if (!NotificationTitle || NotificationTitle.trim() === "") {
            newErrors.NotificationTitle = "Notification title is required.";
        }

        if (selectedNotiType?.value === "email" && (!html || html.trim() === "")) {
            newErrors.html = "Email content is required.";
        }

        if (selectedNotiType?.value !== "email" && (!NotificationBody || NotificationBody.trim() === "")) {
            newErrors.NotificationBody = "Notification body is required.";
        }
        if (selectedDegree.length == 0) {
            newErrors.degree = "Degree is required.";
        }
        if (selectedStudyingYear.length == 0) {
            newErrors.studyingYear = "Studying Year is required.";
        }
        if (!selectedyear) {
            newErrors.year = "Year is required.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0; // true if no errors
    };

    async function fetchDegreeTitles(instituteId = null) {
        if (!instituteId) {
            setError("No Institute Found.");
            return;
        }
        try {
            const response = await fetch(`${LMSBASEURL}/api/degree-titles?institute_id=${instituteId}`, {
                method: "GET",
                headers: {
                    Authorization: "ipVefQSuBvkt4i9AFX3brGOVIEEK6xL4",
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error("Error fetching degree titles:", error);
            return { status: false, message: "Something went wrong", data: [] };
        }
    }

    useEffect(() => {
        const isEdit = Boolean(searchParams.get("edit"));
        const editData = sessionStorage.getItem("editNoti");

        if (isEdit && editData) {
            const d = JSON.parse(editData);
            setSelectedNotiType({
                label: d.type === "fcmnotification" ? "Browser Notification" : "Email Notification",
                value: d.type,
            });

            const programIDs = JSON.parse(d.programs)
            const programTitles = d.program_titles;

            if (programIDs && Array.isArray(programIDs) && Array.isArray(programTitles)) {
                const combined = programIDs.map((id, index) => ({
                    value: id,
                    label: programTitles[index] || null
                }));

                setSelectedProgram(combined);
            }

            setNotoficationTitle(d.title || "");
            if (d.type === "email") {
                setHtml(d.body || "");
            } else {
                setNotificationBody(d.body || "");
            }

            if (d.scheduled_on) {
                setSelectedDate(new Date(d.scheduled_on));
            }
        }
    }, [searchParams]);

    useEffect(() => {
        if (!token) {
            setError("Authentication token not found. Please try logging in again.");
            setLoading(false);
            return;
        }

        async function getPrograms() {
            try {
                const userId = sessionStorage.getItem("id");

                if (!userId) {
                    throw new Error("User ID is missing. Please log in again.");
                }

                const apiUrl = `${LMSBASEURL}/api/institutes/${instituteId}/programs`;

                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': token,
                        'Accept': 'application/json'
                    }
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Unable to load programs. Please try again later. (${response.status})`);
                }

                const data = await response.json();
                if (data?.status && data?.data) {
                    setProgramsListData(
                        data?.data?.map(({ id, program_title }) => ({ value: id, label: program_title }))
                    );
                } else {
                    throw new Error("Invalid response format from server.");
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }

        const loadDegrees = async () => {
            const result = await fetchDegreeTitles(instituteId);
            if (result.status) {
                const deg = result.data?.map((deg) => ({ label: deg, value: deg }))
                setAllDegrees(deg);
            } else {
                setAllDegrees([]);
                console.error(result.message);
            }
        };
        getPrograms();
        loadDegrees();
    }, []);

    useEffect(() => {
        if (selectedProgram.length === 0) {
            setStudentListData([]);
            setSelectedProgramBatch([]);
            return;
        }
        async function getProgramsBatch() {
            try {
                const programIds =
                    selectedProgram.length === 1
                        ? selectedProgram[0].value
                        : selectedProgram.map(p => p.value);

                const payload = {
                    institute_id: parseInt(instituteId),
                    program_id: programIds
                };
                // const payload = {
                //     institute_id: 11,
                //     program_id: 74
                // };

                const response = await fetch(`${LMSBASEURL}/api/batch/by-institute`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": token,
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error(`Unable to load students. (${response.status})`);
                }

                const data = await response.json();

                if (data?.status && Array.isArray(data?.data)) {
                    setStudentBatchListData(data.data.map(({ id, batch_name }) => ({ value: id, label: batch_name })));
                } else {
                    setStudentBatchListData([]);
                }
            } catch (err) {
                console.error("Error fetching students:", err);
                setStudentBatchListData([]);
            }
        }

        getProgramsBatch();
    }, [selectedProgram, instituteId]);

    async function getStudents(pro) {
        try {
            const programIds =
                pro.length === 1
                    ? pro[0].value
                    : pro.map(p => p.value);

            const payload = {
                institute_id: parseInt(instituteId),
                degree_title: selectedDegree.map(s => s.value),
                year: [selectedyear.getFullYear()],
                studying_year: selectedStudyingYear.map(s => s.value),
                program_ids: programIds,
                batch_ids:
                    selectedBatchStudents.length === 1
                        ? [selectedBatchStudents[0].value]
                        : selectedBatchStudents.map(p => p.value),
            };
            setStudendListLoad(true)
            const url = `${LMSBASEURL}/api/students-by-institute`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token,
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`Unable to load students. (${response.status})`);
            }

            const isEdit = Boolean(searchParams.get("edit"));
            const editData = JSON.parse(sessionStorage.getItem("editNoti"));
            const studentIDs = editData?.students ? JSON.parse(editData?.students) : [];

            const data = await response.json();
            if (isEdit && editData) {
                if (Array.isArray(studentIDs) && Array.isArray(data?.data)) {
                    const selected = studentIDs.map((id) => {
                        const studentObj = data?.data?.find((s) => s.id === id);

                        return {
                            value: studentObj.id,
                            label: `${studentObj.first_name} ${studentObj.last_name} (${studentObj?.email}(${studentObj?.degree_title}))`
                        }
                        // : { value: id, label: `Student ${id}` };
                    });

                    setSelectedStudents(selected);
                    setStudentListData(
                        data.data.map(({ id, first_name, last_name, email, degree_title }) => ({
                            value: id,
                            label: `${first_name} ${last_name} (${email}), Degree-(${degree_title})`,
                        }))
                    );
                }
            } else {
                if (data?.status && Array.isArray(data?.data)) {
                    setStudentListData(
                        data.data.map(({ id, first_name, last_name, email, degree_title }) => ({
                            value: id,
                            label: `${first_name} ${last_name} (${email}), Degree-(${degree_title})`,
                        }))
                    );
                } else {
                    setStudentListData([]);
                }
            }
            setStudendListLoad(false)


        } catch (err) {
            console.error("Error fetching students:", err);
            setStudentListData([]);
            setStudendListLoad(false)
        }
    }

    useEffect(() => {
        getStudents(selectedProgram);
    }, [selectedProgram, instituteId, selectedBatchStudents, selectedDegree, selectedyear, selectedStudyingYear]);

    const handleDateChange = async (date) => {
        setSelectedDate(date);
    };

    const sendNotification = async (scheduledOn) => {
        try {
            const selectedStudentIds = selectedStudents.map(s => s.value);
            const programIds = selectedProgram.length === 0 ? null : selectedProgram.length === 1 ? selectedProgram[0].value : selectedProgram.map(p => p.value);
            const batch_ids = selectedBatchStudents.length === 0 ? null : selectedBatchStudents.length === 1 ? selectedBatchStudents[0].value : selectedBatchStudents.map(p => p.value)

            const selectedDegreeIds = selectedDegree.map(s => s.value);
            const selectedStyIds = selectedStudyingYear.map(s => s.value);

            const raw = JSON.stringify({
                type: selectedNotiType?.value,
                programs: programIds,
                students: selectedStudentIds,
                institute_id: parseInt(instituteId),
                title: NotificationTitle,
                body: selectedNotiType?.value === 'email' ? html : NotificationBody,
                scheduled_on: scheduledOn,
                created_by: parseInt(instituteLoginId),
                batch_id: batch_ids,
                degree: selectedDegree ? selectedDegreeIds : null,
                year: selectedyear ? selectedyear.getFullYear() : null,
                studying_year: selectedStudyingYear ? selectedStyIds : null
            });

            const response = await fetch(`${LMSBASEURL}/api/add-notifications`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token,
                },
                body: raw,
            });

            if (!response.ok) {
                throw new Error(`Unable to add notification. (${response.status})`);
            }

            const data = await response.json();
            if (data?.status) {
                setSelectedNotiType(null);
                setSelectedProgram([]);
                setSelectedStudents([]);
                setNotificationBody('');
                setNotoficationTitle('');
                setHtml('');
                setSelectedDegree([]);
                setSelectedStudyingYear([]);
                setSelectedYear(new Date())

                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: data?.status?.message || "Notification sent successfully",
                    confirmButtonColor: '#007bff',
                    confirmButtonText: 'OK',
                    customClass: { popup: 'rounded-lg' }
                });

                setTimeout(() => {
                    navigate('/announcement');
                }, 2000);
            }
        } catch (err) {
            console.error("Error sending notification:", err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong while sending notification.',
                confirmButtonColor: '#007bff',
            });
        }
    };

    const handleSendNotification = (e) => {
        if (validateForm()) {
            e.preventDefault();
            sendNotification(selectedDate);
        }
    };

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            border: errors.selectedNotiType ? "1px solid red" : "1px solid #ced4da",
            boxShadow: 'none',
            '&:hover': {
                border: "1px solid #ced4da",
            },

            minHeight: "38px",
            fontSize: "14px",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#495057",
        }),
    }

    const handleEnterTitle = (e) => {
        // let sanitizedValue = e.target.value.replace(/[^A-Za-z0-9 ]/g, "");
        setNotoficationTitle(e.target.value)
    }

    // const allDegrees = stream_data.streams.flatMap(stream => stream.degrees?.map((deg)=>({label: deg?.name,value: deg?.name})));
    const studyingYearOptions = stream_data.studying_years.map((y) => ({ label: y, value: y }));

    const handleReset = () => {
        setSelectedNotiType(null);
        setSelectedProgram([]);
        setSelectedStudents([]);
        setNotificationBody('');
        setNotoficationTitle('');
        setHtml('');
        setSelectedDegree([]);
        setSelectedStudyingYear([]);
        setSelectedYear(new Date())
    }

    const handleFilterChange = (filters) => {
        setFilterValues(filters);
    };

    return (
        <>
            <div className="col-12">
                <PageHeader title="Notification"
                    breadcrumbs={[
                        { label: "Dashboard", path: dashboardPath },
                        { label: "Notification", active: true }
                    ]}
                />
            </div>
            <div className='p-2'>
                <div className="row mb-4 bg-white rounded py-3 px-2 g-2 mx-1 border">
                    <div className="col-12 mb-2">
                        <label className="form-label">
                            <i className="ri-edit-line me-1"></i>
                            Create Notification
                        </label>
                    </div>
                    <div className={"col-lg-3 col-md-12"}>
                        <div className="mb-2">
                            <label className="form-label  fw-bold  small mb-1">Notification Type<span className="text-danger">*</span></label>
                            <Select
                                options={[
                                    {
                                        label: "Browser Notification",
                                        value: "fcmnotification"
                                    },
                                    {
                                        label: "Email Notification",
                                        value: "email"
                                    }]}
                                value={selectedNotiType}
                                onChange={setSelectedNotiType}
                                placeholder="Select Type"
                                styles={customSelectStyles}
                                isClearable
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            />
                            {errors.selectedNotiType && <div className="text-danger small mt-1">{errors.selectedNotiType}</div>}
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="mb-2">
                            <label className="form-label  fw-bold  small mb-1">Passing Year <span className="text-danger">*</span></label>
                            <DatePicker
                                selected={selectedyear}
                                onChange={(val) => {
                                    setSelectedYear(val);
                                    setErrors((prev) => ({ ...prev, year: null }));
                                }}
                                showYearPicker
                                required
                                dateFormat="yyyy"
                                yearItemNumber={9}
                                placeholderText="Select Year"
                                className={`form-control ${errors.year && 'border border-danger'}`}
                                maxDate={new Date()}
                            />
                            {errors.year && <div className="text-danger small mt-1">{errors.year}</div>}
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="mb-2">
                            <label className="form-label  fw-bold  small mb-1">Degree Name <span className="text-danger">*</span></label>
                            <ReactMultiSelect
                                name="degree"
                                showSelectAll={false}
                                options={allDegrees}
                                value={selectedDegree}
                                onChange={(val) => {
                                    setSelectedDegree(val);
                                    setErrors((prev) => ({ ...prev, degree: null }));
                                }}
                                placeholder={"Select Degree"}
                                styles={customSelectStyles}
                                isClearable
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                    MultiValue: () => null,
                                }}
                                hasError={errors.degree ? true : false}
                            />
                            {errors.degree && <div className="text-danger small mt-1">{errors.degree}</div>}
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="mb-2">
                            <label className="form-label  fw-bold  small mb-1">
                                Studying Year <span className="text-danger">*</span>
                            </label>
                            <ReactMultiSelect
                                name="studyingYear"
                                showSelectAll={false}
                                options={studyingYearOptions}
                                value={selectedStudyingYear}
                                onChange={(val) => {
                                    setSelectedStudyingYear(val);
                                    setErrors((prev) => ({ ...prev, studyingYear: null }));
                                }}
                                placeholder="Select Studying Year"
                                styles={customSelectStyles}
                                isClearable
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                    MultiValue: () => null,
                                }}
                                hasError={errors.studyingYear ? true : false}
                            />
                            {errors.studyingYear && <div className="text-danger small mt-1">{errors.studyingYear}</div>}
                        </div>
                    </div>
                    {getProgramId &&
                        <div className={"col-md-3 col-12"}>
                            <div className="mb-2">
                                <label className="form-label  fw-bold  small mb-1">Select Program</label>
                                <ReactMultiSelect
                                    isMulti
                                    value={selectedProgram}
                                    closeMenuOnSelect={false}
                                    onChange={setSelectedProgram}
                                    getOptionLabel={(e) => e.label}
                                    getOptionValue={(e) => e.value}
                                    OptionLabel="label"
                                    ValueLabel="value"
                                    options={programsListData}
                                    placeholder="Select Programs"
                                    hasError={errors.selectedProgram ? true : false}
                                />
                                {errors.selectedProgram && <div className="text-danger small mt-1">{errors.selectedProgram}</div>}
                            </div>
                        </div>}
                    {/* {getProgramId &&
                    <div className="col-md-2 col-sm-12">
                        <div className="mb-2">
                            <label className="form-label  fw-bold  small mb-1">Program Batch</label>
                            <ReactMultiSelect
                                isMulti
                                value={selectedBatchStudents}
                                closeMenuOnSelect={false}
                                onChange={setSelectedBatchStudents}
                                getOptionLabel={(e) => e.label}
                                getOptionValue={(e) => e.value}
                                OptionLabel="label"
                                ValueLabel="value"
                                noOptionsMessage={selectedProgram?.length == 0 ? "Please Select Program First" : studentBatchListData?.length == 0 && "No Batch Found"}
                                options={studentBatchListData}
                                placeholder="Select Batch"
                                hasError={false}
                            />
                        </div>
                    </div>} */}
                    {selectedNotiType?.value != "bulk" &&
                        <div className="col-md-3 col-12">
                            <div className="mb-2">
                                <label className="form-label  fw-bold  small mb-1">Select Student<span className="text-danger">*</span></label>
                                {/* <LazyAsyncSelect vendorOptions={studentListData}/> */}
                                <ReactMultiSelect
                                    isLoading={studendListLoad}
                                    isMulti
                                    value={selectedStudents}
                                    closeMenuOnSelect={false}
                                    onChange={setSelectedStudents}
                                    getOptionLabel={(e) => e.label}
                                    getOptionValue={(e) => e.value}
                                    OptionLabel="label"
                                    ValueLabel="value"
                                    noOptionsMessage={"No Student Found"}
                                    options={studentListData}
                                    placeholder="Select Students"
                                    hasError={errors.selectedStudents ? true : false}
                                />
                                {errors.selectedStudents && <div className="text-danger small mt-1">{errors.selectedStudents}</div>}
                            </div>
                        </div>}
                    {/* <div className="col-lg-3">
                        <div className="mb-2">
                        <label className="form-label  fw-bold  small mb-1">By Percentage:</label>
                        {isMobile? <MobilePercentageFilter/> : <PercentageFilter onFiltersChange={handleFilterChange} rightCss={68} transformCss={20}/>}
                        </div>
                    </div> */}

                    {/* <div className="col-12 col-md-1">
                        <label className="form-label  fw-bold  small mb-1">
                        Reset
                        </label>
                        <button
                            className="btn btn-danger w-75 rounded-3"
                            onClick={handleReset}
                            disabled={ 
                                !selectedNotiType &&
                                !selectedBatchStudents &&
                                !NotificationTitle &&
                                !selectedNotiType &&
                                !selectedDegree && 
                                !selectedStudyingYear 
                            }
                        >
                            <X size={16} className="" style={{ verticalAlign: 'middle' }} />
                        </button>
                    </div> */}
                    <div className='col-12'>
                        <PercentageFilter onFiltersChange={handleFilterChange} degreeArr={selectedDegree}/>
                    </div>

                    <div className='col-12 mt-4'>
                        <form className="mt-2">
                            <div className="row g-3">

                                <div className="col-12">
                                    <label htmlFor="title" className="form-label">Title<span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.NotificationTitle ? "is-invalid" : ""} `}
                                        id="title"
                                        placeholder="Enter Notification Title"
                                        onChange={handleEnterTitle}
                                        value={NotificationTitle}
                                    />
                                    {errors.NotificationTitle && <div className="text-danger small mt-1">{errors.NotificationTitle}</div>}
                                </div>
                                <div className="col-12">
                                    <label htmlFor="body" className="form-label">Body <span className="text-danger">*</span></label>
                                    {selectedNotiType?.value == 'email' ?
                                        <>
                                            <EmailEditor
                                                ref={editorRef}
                                                isError={errors.html ? true : false}
                                                onChange={setHtml} placeholder="Write Your..."
                                                initialHtml={html}
                                            />
                                            {errors.html && <div className="text-danger small mt-1">{errors.html}</div>}
                                        </>

                                        :
                                        <textarea
                                            id="body"
                                            className={`form-control bg-light border-light border ${errors.NotificationBody ? "is-invalid" : ""}`}
                                            rows="3"
                                            placeholder="Write Notification Body"
                                            value={NotificationBody}
                                            onChange={(e) => setNotificationBody(e.target.value)}
                                            required
                                        />}
                                    {errors.NotificationBody && <div className="text-danger small mt-1">{errors.NotificationBody}</div>}
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="body" className="form-label">Schedule</label>
                                        <DatePicker
                                            selected={selectedDate}
                                            onChange={handleDateChange}
                                            timeInputLabel="Time:"
                                            dateFormat="MM/dd/yyyy h:mm aa"
                                            showTimeInput
                                            // showIcon
                                            placeholderText="Schedule"
                                            shouldCloseOnSelect={false}
                                            className="form-control datepickerheight"
                                        />
                                        {errors.selectedDate && <div className="text-danger small mt-1">{errors.selectedDate}</div>}
                                    </div>
                                </div>

                                <div className="col-12 col-md-12" style={{ marginLeft: 10 }}>
                                    <div className="mb-3">
                                        <div className="d-flex align-items-start align-items-md-center gap-2">
                                            <button
                                                className="btn btn-primary"
                                                onClick={handleSendNotification}
                                                type="button"
                                            >
                                                {isSameDate(new Date(selectedDate), new Date()) ?
                                                    <><i className="ri-send-plane-line me-1"></i>Submit</>
                                                    :
                                                    <>< i class="ri-time-line me-1"></i>Schedule {selectedNotiType?.label || "Message"}</>
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <style>

                {`
                .react-datepicker-wrapper,
                    .react-datepicker__input-container {
                    display: block;
                    width: 100%;    
                }
                .datepickerheight{
                    height:37px;
                    color:#6d6e72;
                    font-size:14px;
                }
                
                `}
            </style>
        </>

    )
}

export default CreateInstituteAnnouncement
